import { Address, ToolkitListingID, isToolkitListingID, isUndefined } from '@aloft/toolkit-shared';

import { ReferenceViewID, parseReferenceViewID } from '..';
import { ReferenceBarPropertyMetadataByID } from '../../../controller/types.js';

export function addressAndListingIDFromReferenceViewID(
  activeID: ReferenceViewID,
  metadataByID: ReferenceBarPropertyMetadataByID,
): {
  listingID: ToolkitListingID | undefined;
  isSubject: boolean;
  address: Address | undefined;
} {
  if (isToolkitListingID(activeID)) {
    return {
      listingID: activeID,
      isSubject: false,
      address: undefined,
    };
  }
  const metadata = metadataByID[activeID];
  const parsed = parseReferenceViewID(activeID);
  if (isUndefined(parsed) || parsed === null || !('type' in parsed)) {
    throw Error(`Invalid ReferenceViewID provided: ${activeID}`);
  }
  if (parsed.type === 'subject') {
    return {
      listingID: metadata?.listingID,
      isSubject: true,
      address: metadata?.address,
    };
  } else {
    return {
      listingID: metadata?.listingID,
      isSubject: false,
      address: metadata?.address,
    };
  }
}
